export var GcpNetworkType;
(function (GcpNetworkType) {
    GcpNetworkType["GCP_NETWORK_TYPE_UNSPECIFIED"] = "UNSPECIFIED";
    GcpNetworkType["GCP_NETWORK_TYPE_PUBLIC"] = "PUBLIC";
    GcpNetworkType["GCP_NETWORK_TYPE_PRIVATE"] = "PRIVATE";
})(GcpNetworkType || (GcpNetworkType = {}));
